import isEqual from "lodash/isEqual";
import { paragraphNodeSpec } from "../extensions/base/paragraphNodeSpec";
import { normalizeDoc } from "../helpers/normalization";
export const EMPTY_P = {
    type: "doc",
    content: [{ type: "paragraph", attrs: { textAlign: null } }],
};
export const EMPTY_P_WITH_PARAMS = {
    type: "doc",
    content: [
        {
            type: "paragraph",
            attrs: {
                textAlign: paragraphNodeSpec.paragraph.attrs.textAlign.default,
                size: paragraphNodeSpec.paragraph.attrs.size.default,
            },
        },
    ],
};
export const EMPTY_P_TEXT = {
    type: "doc",
    content: [
        {
            type: "paragraph",
            attrs: { textAlign: null },
            content: [{ type: "text", text: "" }],
        },
    ],
};
export const isDocEmpty = (doc) => {
    if (!doc || !doc.content) {
        return true;
    }
    const normalizedDoc = normalizeDoc({
        type: "doc",
        content: doc.content,
    });
    return (!normalizedDoc.content.length ||
        isEqual(normalizedDoc, EMPTY_P) ||
        isEqual(normalizedDoc, EMPTY_P_TEXT) ||
        isEqual(normalizedDoc, EMPTY_P_WITH_PARAMS));
};
export const isDocHtmlEmpty = (html) => {
    return html === "" || html === "<p></p>";
};
